<template>
    <div class="footer">
        <div class="foot">
            <div class="foot-w clearfix">
                <div class="foot-left-nav" :class="{'en': language == 'en', 'es': language == 'es'|| language == 'fr'|| language == 'ru'}">
                    <div class="foot-nav clearfix">
                        <a :href="'https://www.chineseplus.net/about-us?lang='+language">{{ $t('message.aboutUs') }}</a><span>|</span>
                        <a :href="'https://www.chineseplus.net/statement?lang='+language">{{ $t('message.statement') }}</a>
                    </div>
                    <p class="foot-copyright">{{ $t('message.copyRight') }}</p>
                    <p class="foot-copyright">{{ $t('message.beian') }}<a href="https://beian.miit.gov.cn/" target="_blank"><img src="../img/footer/ba.png?v=2.2.7">{{ $t('message.beian_1') }}</a></p>
                </div>
                <div class="alliance" :class="{ 'es': language == 'es'|| language == 'fr'}">
                    <div style="text-align: center;position: relative;" id="liveclient">
                        <a href="https://pan-chinesecio.oss-cn-beijing.aliyuncs.com/data/setup-official.zip" target="_blank">
                        <!--<a href="javascript:;" id="live_client_download">-->
                            <img :title="$t('message.downLoadApp')" src="../img/footer/liveclient20210809.png?v=2.3.2" width="50px" style="display: block;font-size: 0;margin: auto;">
                        </a>
                    </div>
                </div>
                <div class="alliance" :class="{ 'es': language == 'es'|| language == 'fr'|| language == 'ru'}">
                    
                    <div id="apks">
                        <div class="apl_box">
                            <img src="../img/footer/1590656011.png?v=2.2.7">
                            <p v-html="$t('message.codeToApp')"></p>
                            <div class="arrow"></div>
                        </div>
                        <img src="../img/footer/app.png?v=2.2.7" class="apk"  @mouseover="showApp()" @mouseout="hideApp()">
                    </div>
                </div>
                <div class="follow-us">
                    <h4>{{ $t('message.followUs') }}</h4>
                    <div class="follow-us-share">
                        <div class="weixin code_1">
                            <img src="../img/footer/fb.png?v=2.2.7">
                            <p>{{ $t('message.qr') }}<br>{{ $t('message.followFacebook') }}</p>
                            <div class="arrow"></div>
                        </div>
                        <div class="weixin code_2">
                            <img src="../img/footer/tw.png?v=2.2.7">
                            <p>{{ $t('message.qr') }}<br>{{ $t('message.followTwitter') }}</p>
                            <div class="arrow"></div>
                        </div>
                        <div class="weixin code_3">
                            <img src="../img/footer/608241732fa1c.png">
                            <p>{{ $t('message.qr') }}<br>{{ $t('message.followWechat') }}</p>
                            <div class="arrow"></div>
                        </div>
                        <div class="weixin code_4">
                            <img src="../img/footer/wb.png?v=2.2.7">
                            <p>{{ $t('message.qr') }}<br>{{ $t('message.followWeibo') }}</p>
                            <div class="arrow"></div>
                        </div>
                        <div class="weixin code_5">
                            <img src="../img/footer/qr_tiktok.png?v=2.2.7">
                            <p>{{ $t('message.qr') }}<br>{{ $t('message.followDouyin') }}</p>
                            <div class="arrow"></div>
                        </div>
                        <a href="javascrit:;"><img src="../img/footer/facebook.png?v=2.2.7" @mouseover="showFollow(0)" @mouseout="hideFollow(0)"></a>
                        <a href="javascrit:;"><img src="../img/footer/twitter.png?v=2.2.7" @mouseover="showFollow(1)" @mouseout="hideFollow(1)"></a>
                        <a href="javascrit:;"><img src="../img/footer/wechat.png?v=2.2.7" @mouseover="showFollow(2)" @mouseout="hideFollow(2)"></a>
                        <a href="javascrit:;"><img src="../img/footer/weibo.png?v=2.2.7" @mouseover="showFollow(3)" @mouseout="hideFollow(3)"></a>
                        <a href="javascrit:;"><img src="../img/footer/tiktok.png?v=2.2.7" @mouseover="showFollow(4)" @mouseout="hideFollow(4)"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'pcfooter',
    data: function () {
        return {
            appIsShow: false
        }
    },
    computed: {
        language () {
            return this.$i18n.locale
        }
    },
    methods: {
        showApp() {
            $('.apl_box').fadeIn()
        },
        hideApp() {
            $('.apl_box').fadeOut()
        },
        showFollow(index) {
            $('.follow-us-share .weixin:eq('+index+')').fadeIn()
        },
        hideFollow(index) {
            $('.follow-us-share .weixin:eq('+index+')').fadeOut()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer {
    width: 100%;
    height: 230px;
    color: #fff;
    font-size: 16px;
    line-height: 30px;
    box-sizing: border-box;
    padding-top: 100px;
    margin-top: 20px;
    a {
        text-decoration: none;
    }
    .clearfix:after {
        content:""; 
        display: block; 
        clear:both; 
    }
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .foot{
        width: 100%;
        height: 130px;
        background: #364347;
        position: relative;
        z-index: 2;
    }
    .foot.fixed{
        position: fixed;
        bottom: 0;
    }
    .foot-w{
        width: 1260px;
        margin: auto;
        padding-top: 20px;
    }
    .foot-logo{
        width: 86px;
        height: 88px;
    }
    .foot-logo img{
        display: block;
        width: 100%;
        font-size: 0;
    }
    .foot-left-nav{
        float: left;
        margin-left: 5px;
        margin-right: 181px;
        &.en {
            margin-right: 80px;
        }
        &.es {
            margin-right: 17px;
        }
    }
    .foot-left-nav .foot-nav{
        line-height: 30px;
    }
    .foot-left-nav .foot-nav a{
        float: left;
        margin-right: 15px;
        font-size: 14px;
        color: #ffffff;
        max-width: 185px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .foot-left-nav .foot-nav span{
        float: left;
        margin-right: 15px;
        font-size: 16px;
        color: #ffffff;
    }
    .foot-copyright{
        color: rgba(255, 255, 255, 0.6);
        font-size: 14px;
        line-height: 30px;
        text-align: left;
    }
    .foot-copyright a{
        color: rgba(255, 255, 255, 0.6);
        font-size: 14px;
        margin-right: 10px;
    }
    .foot-copyright a img{
        vertical-align: middle;
        position: relative;
        top: -2px;
        margin: 0 5px;
    }
    .alliance{
        width: 80px;
        float: left;
        margin-left: 32px;
        margin-top: 10px;
        line-height: 1.2;
        &.es {
            margin-left: 20px;
        }
        #apks {
            text-align: center;
            position: relative;
        }
        .apk {
            width: 50px;
            cursor: pointer;
        }
        .apl_box {
            display: none;
            position: absolute;
            top: -165px;
            right: -33px;
            width: 150px;
            height: 155px;
            background-color: #fff;
            border-radius: 8px;
            text-align: center;
            img {
                width: 100px;
                height: 100px;
                margin-top: 5px;
                cursor: pointer;
            }
            p {
                color: #333;
                font-size: 12px;
                margin: 0;
                opacity: 0.6;
                padding-bottom: 6px;
            }
            .arrow {
                width: 0;
                height: 0;
                border-width: 10px;
                border-style: solid;
                border-color: #fff transparent transparent transparent;
                position: absolute;
                bottom: -20px;
                left: 50%;
                margin-left: -10px;
            }
        }
    }
    .alliance h4{
        color: #ffffff;
        font-size: 16px;
        line-height: 30px;
        margin-bottom: 10px;
        text-align: center;
    }
    .alliance-list{
        width: 83px;
        height: 50px;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
    }
    .alliance-list .swiper-wrapper{
        width: 100px;
        height: 50px;
        margin: auto;
        display: flex;
        position: relative;
    }
    .alliance-item{
        opacity: 0;
        flex-shrink: 0;
        width: 100%;
        height: 100%;
        position: relative;
        transition-property: transform;
    }
    .alliance-item a{
        display: block;
        width: 57px;
        height: 50px;
        margin: auto;
    }
    .alliance-item img{
        width: 57px;
        height: 50px;
        display: block;
        font-size: 0;
    }
    .follow-us{
        float: right;
        margin-right: 30px;
    }
    .follow-us h4{
        color: #ffffff;
        font-size: 14px;
        line-height: 30px;
        margin-top: 20px;
        text-align: center;
        float: left;
        font-weight: bold;
    }
    .follow-us .follow-us-share{
        display: flex;
        justify-content: space-between;
        margin-top: 15px;
        position: relative;
        float: left;
        margin-left: 10px;
        .weixin {
            display: none;
            position: absolute;
            top: -165px;
            right: 41px;
            width: 150px;
            height: 155px;
            background-color: #fff;
            border-radius: 8px;
            text-align: center;
            img {
                width: 100px;
                height: 100px;
                margin-top: 5px;
            }
            p {
                color: #333;
                font-size: 12px;
                margin: 0;
                opacity: 0.6;
                line-height: 1.2;
                padding-bottom: 6px;
            }
            .arrow {
                width: 0;
                height: 0;
                border-width: 10px;
                border-style: solid;
                border-color: #fff transparent transparent transparent;
                position: absolute;
                bottom: -20px;
                left: 50%;
                margin-left: -10px;
            }
        }
        .weixin:nth-of-type(1){
            right: 136px;
        }
        .weixin:nth-of-type(2){
            right: 89px;
        }
        .weixin:nth-of-type(4){
            right: -8px;
        }
        .weixin:nth-of-type(5){
            right: -55px;
        }

    }
    .follow-us .follow-us-share a{
        display: inline-block;
        margin-left: 10px;
        width: 38px;
        height: 38px;
        -webkit-transition: all 0.2s;
        transition: all 0.2s;
    }
    .follow-us .follow-us-share a:hover{
        transform: scale(1.05);
        -webkit-filter: brightness(1.03);
        filter: brightness(1.03);
    }
    .follow-us .follow-us-share a img{
        display: block;
        width: 100%;
        height: 100%;
        font-size: 0;
    }
}
</style>
